import htmlParser from 'html-react-parser'
import React from 'react'

export const HtmlParser: TFCC<{ children: string }> = ({ children }) => <>{htmlParser(children)}</>
